import styled from "styled-components";
import closeIcon from "../../images/icons/closeIcon.png";
const Container = styled.img`
  width: 10.2px;
  height: 10.2px;
  cursor: pointer;
`;
function CloseIcon({ onclick }) {
  return <Container src={closeIcon} onClick={onclick} />;
}

export default CloseIcon;
